import useSWR from 'swr';
import { getNestedMetaDataFetcher, postDataFetcher } from '@/utils/apis';
import { apiURL, ListMetaResponse } from '@/constant/apiURL';
import { BaseValue, queryBuilder } from '@/utils/urls';
import { TalkFlowDocument } from '@/types/talk_flow';
import { RecentShareScope, RecentShareTarget } from '@/types/api';

interface TalkFlowDocumentListParams {
  listSize?: number;
  currentPage?: number;
  sortType?: string;
  orderType?: string;
  createdBy?: string;
  isTemporary?: number;
  keyword?: string;
  isOnlyShared?: number;
  isRead?: boolean;
  documentType?: string;
}

export const useGetTalkFlowDocumentList = (
  params: TalkFlowDocumentListParams = {},
) => {
  const query = queryBuilder(
    params as Record<string, BaseValue | BaseValue[]>,
    { includeQuestionMark: true },
  );

  const url = `${apiURL.TALK_FLOW_DOCUMENT_LIST}${query}`;
  const { data, error, isLoading } = useSWR<{
    meta: ListMetaResponse;
    data: TalkFlowDocument[];
  }>(url, getNestedMetaDataFetcher);

  return { data, error, isLoading };
};

/**
 * 최근 공유 대상(개인·법인·사업부·팀) 목록 페이지 조회
 * - 기존 /share/recent(5명 고정)를 대체하는 API
 */
export const useRecentShareTargets = (
  params: {
    excludePassportIds?: string[];
    excludeRoleIds?: string[];
    currentPage?: number;
    listSize?: number;
  } = {},
) => {
  const queryParams: Record<string, BaseValue | BaseValue[] | undefined> = {
    excludePassportIds: params.excludePassportIds?.length
      ? params.excludePassportIds
      : undefined,
    excludeRoleIds: params.excludeRoleIds?.length
      ? params.excludeRoleIds
      : undefined,
    currentPage: params.currentPage,
    listSize: params.listSize,
  };
  // queryBuilder 가 undefined 값은 걸러낸다
  const query = queryBuilder(
    queryParams as Record<string, BaseValue | BaseValue[]>,
    { includeQuestionMark: true },
  );

  return useSWR<{ meta: ListMetaResponse; data: RecentShareTarget[] }>(
    `${apiURL.TALK_FLOW_SHARE_RECENT_TARGETS}${query}`,
    getNestedMetaDataFetcher,
  );
};

/**
 * 최근 공유한 사람 목록에 추가
 */
export const addRecentSharedPassports = (passportIds: string[]) => {
  const targets: RecentShareScope[] = passportIds.map((value) => ({
    type: 'passport',
    value,
  }));
  return postDataFetcher<{ targets: RecentShareScope[] }>(
    apiURL.TALK_FLOW_SHARE_RECENT,
    { targets },
  );
};
